/*******************************************************************************
 * Copyright (c) 2024-2025 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

import {Injectable, inject} from '@angular/core';
import {Store} from '@ngrx/store';
import * as TokenActions from '@shared/common-core/store/actions/token.actions';
import {AppActions} from '@shared/common-core/store/actions';
import {THEME_STORAGE_KEYS} from '@shared/models/psp-theme';
import {BULK_IMPORT_STORAGE_KEYS} from '@shared/models/bulk-import';
import {Router} from '@angular/router';
import {EnvironmentConfig} from '@shared/models/environment-config';
import {APP_CONFIG} from '@common-core/config/app-config';
import {LocalStorageService} from '@common-services/local-storage/local-storage.service';
import {LOCALE_STORAGE_KEYS} from '@common-core/config/locale/locale.service';

/**
 * This helper is used for authentication.
 */
@Injectable({
  providedIn: 'root',
})
export class AuthHelper {
  private store = inject(Store);
  private router = inject(Router);
  private appConfig = inject<EnvironmentConfig>(APP_CONFIG);
  private localStorageService = inject(LocalStorageService);

  isGmf: boolean = this.appConfig.cloudEnvironment.includes('gmf');

  public logout(): void {
    this.store.dispatch(AppActions.closeJiraModal());
    this.store.dispatch(TokenActions.clearTokens());

    const theme = this.localStorageService.getItem(THEME_STORAGE_KEYS.theme);
    const locale = this.localStorageService.getItem(LOCALE_STORAGE_KEYS.locale);
    const hideBulkModal = this.localStorageService.getItem(
      BULK_IMPORT_STORAGE_KEYS.hideBulkModal
    );
    const isClient = this.localStorageService.getItem('client');
    this.localStorageService.clear();
    if (theme) this.localStorageService.setItem(THEME_STORAGE_KEYS.theme, theme);
    if (locale) this.localStorageService.setItem(LOCALE_STORAGE_KEYS.locale, locale);
    if (hideBulkModal)
      this.localStorageService.setItem(BULK_IMPORT_STORAGE_KEYS.hideBulkModal, hideBulkModal);
    if (isClient) this.localStorageService.setItem('client', isClient);

    this.store.dispatch(AppActions.resetStoreState());
  }

  public redirectToLogin(): void {
    const isClient = JSON.parse(this.localStorageService.getItem('client') || 'false');
    const route = this.isGmf
      ? isClient
        ? 'gmf/auth/client/login'
        : 'gmf/auth/login'
      : 'auth';
    this.router.navigate([route]);
  }
}
